export default __webpack_public_path__ + "static/media/view_icon.2c652977.PNG";